import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BillingDetailsDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.BillingDetailsDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BillingDetailsDTO.translate = translateService;
}
this.Company = null;
this.Email = null;
this.AddressLine1 = null;
this.AddressLine2 = null;
this.City = null;
this.PostalCode = null;
this.CountryCode = null;
this.VAT = null;
this.BillingDetailsDTOKey = null;
this._key = this.BillingDetailsDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Company:any;
Email:any;
AddressLine1:any;
AddressLine2:any;
City:any;
PostalCode:any;
CountryCode:any;
VAT:any;
private _BillingDetailsDTOKey:any;
get BillingDetailsDTOKey(): any {
    return this._BillingDetailsDTOKey;
  }
set BillingDetailsDTOKey(value: any) {
    this._BillingDetailsDTOKey = value;
    this._key = value;
  }

static ToDTO(details: any): any{let dto = new Domain.BillingDetailsDTO();
dto.Company = details?.Company;
dto.CountryCode = details?.CountryCode;
dto.City = details?.City;
dto.PostalCode = details?.PostalCode;
dto.AddressLine1 = details?.AddressLine1;
dto.AddressLine2 = details?.AddressLine2;
dto.Email = details?.Email;
dto.VAT = details?.VAT;
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BillingDetailsDTOKey == null || $this.BillingDetailsDTOKey == 0;
            }


}